import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_BENEFIT_TYPE, GET_BENEFIT_TYPE_SUCCESS, GET_BENEFIT_TYPE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getBenefitTypes({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/benefit-types`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_BENEFIT_TYPE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BENEFIT_TYPE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BENEFIT_TYPE_ERROR, payload: error });
  }
}

export function* watchgetBenefitTypes() {
  yield takeEvery(GET_BENEFIT_TYPE, getBenefitTypes);
}

function* getBenefitTypesSaga() {
  yield all([fork(watchgetBenefitTypes)]);
}

export default getBenefitTypesSaga;